import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/views/layout/Layout';

/** note: Submenu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    perms: ['GET /aaa','POST /bbb']     will control the page perms (you can set multiple perms)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
**/
export var constantRouterMap = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component() {
      return import('@/views/redirect/index');
    }
  }]
}, {
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/auth-redirect',
  component: function component() {
    return import('@/views/login/authredirect');
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/errorPage/404');
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return import('@/views/errorPage/401');
  },
  hidden: true
}, {
  path: '',
  component: Layout,
  redirect: 'dashboard',
  children: [{
    path: 'dashboard',
    component: function component() {
      return import('@/views/dashboard/index');
    },
    name: 'Dashboard',
    meta: {
      title: '首页',
      icon: 'dashboard',
      affix: true
    }
  }]
}];
export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: constantRouterMap
});
export var asyncRouterMap = [{
  path: '/intermediary',
  component: Layout,
  redirect: 'noredirect',
  alwaysShow: true,
  name: 'intermediaryManage',
  meta: {
    title: '中介管理',
    icon: 'data'
  },
  children: [{
    path: 'intermediaryList',
    component: function component() {
      return import('@/views/intermediary/intermediaryList');
    },
    name: 'intermediaryList',
    meta: {
      title: '中介管理列表',
      noCache: true,
      icon: 'intermediary'
    },
    hidden: false
  }, {
    path: 'addIntermediary',
    component: function component() {
      return import('@/views/intermediary/addIntermediary');
    },
    name: 'addIntermediary',
    meta: {
      title: '新建中介',
      noCache: true,
      icon: 'code'
    },
    hidden: true
  }, {
    path: 'updataIntermediary',
    component: function component() {
      return import('@/views/intermediary/addIntermediary');
    },
    name: 'updataIntermediary',
    meta: {
      title: '编辑中介',
      noCache: true,
      icon: 'code'
    },
    hidden: true
  }]
}, {
  path: '/community',
  component: Layout,
  redirect: 'noredirect',
  alwaysShow: true,
  name: 'communityManage',
  meta: {
    title: '小区管理',
    icon: 'data'
  },
  children: [{
    path: 'communityList',
    component: function component() {
      return import('@/views/community/communityList');
    },
    name: 'communityList',
    meta: {
      title: '小区管理列表',
      noCache: true,
      icon: 'community'
    },
    hidden: false
  }, {
    path: 'addCommunity',
    component: function component() {
      return import('@/views/community/addCommunity');
    },
    name: 'addCommunity',
    meta: {
      title: '新建小区',
      noCache: true,
      icon: 'code'
    },
    hidden: true
  }, {
    path: 'updataCommunity',
    component: function component() {
      return import('@/views/community/addCommunity');
    },
    name: 'updataCommunity',
    meta: {
      title: '编辑小区',
      noCache: true,
      icon: 'code'
    },
    hidden: true
  }, {
    path: 'communityDetails',
    component: function component() {
      return import('@/views/community/communityDetails');
    },
    name: 'communityDetails',
    meta: {
      title: '小区详情',
      noCache: true,
      icon: 'code'
    },
    hidden: true
  }]
}, {
  path: '/manageModule',
  component: Layout,
  redirect: 'noredirect',
  alwaysShow: true,
  name: 'manageModule',
  meta: {
    title: '管理模块',
    icon: 'data'
  },
  children: [{
    path: 'houseManageList',
    component: function component() {
      return import('@/views/house/houseManageList');
    },
    name: 'houseManageList',
    meta: {
      title: '房源管理',
      noCache: true,
      icon: 'house'
    },
    hidden: false
  }, {
    path: 'houseDetails',
    component: function component() {
      return import('@/views/house/houseDetails');
    },
    name: 'houseDetails',
    meta: {
      title: '房源详情',
      noCache: true,
      icon: 'code'
    },
    hidden: true
  }, {
    path: 'userManageList',
    component: function component() {
      return import('@/views/userManage/userManageList');
    },
    name: 'userManageList',
    meta: {
      title: '用户管理',
      noCache: true,
      icon: 'customer'
    },
    hidden: false
  }, {
    path: 'userDetails',
    component: function component() {
      return import('@/views/userManage/userDetails');
    },
    name: 'userDetails',
    meta: {
      title: '用户详情',
      noCache: true,
      icon: 'code'
    },
    hidden: true
  }, {
    path: 'tagManageList',
    component: function component() {
      return import('@/views/tag/index.vue');
    },
    name: 'tagManageList',
    meta: {
      title: '标签管理',
      noCache: true,
      icon: 'tag'
    },
    hidden: false
  }, {
    path: 'activityManageList',
    component: function component() {
      return import('@/views/house/activityManageList.vue');
    },
    name: 'activityManageList',
    meta: {
      title: '活动管理',
      noCache: true,
      icon: 'activity'
    },
    hidden: false
  }, {
    path: 'payOrderList',
    component: function component() {
      return import('@/views/payOrder/index.vue');
    },
    name: 'payOrderList',
    meta: {
      title: '订单管理',
      noCache: true,
      icon: 'order'
    },
    hidden: false
  }]
}, {
  path: '*',
  redirect: '/404',
  hidden: true
}];